import styled, { css } from 'styled-components';
import { setLayoutWidth } from '../../styles/sharedStyles';
import Carousel from 'react-multi-carousel';

export const HeroBannerContainer = styled.div`
  height: calc(100vw * 0.28);
  position: relative;
  cursor: pointer;
  ${({ theme }) => theme.breakpoints.down('sm')} {
    height: calc(100vw * 0.3);
  }
`;

const centerAbsolutePositionElement = css`
  left: 10%;
  right: 0px;
  margin-left: auto;
  margin-right: auto;
`;

export const HeaderContent = styled.div`
  ${setLayoutWidth};
  ${centerAbsolutePositionElement};
  position: absolute;
  top: 20%;
  color: rgba(32, 154, 214, 1);
  text-align: left;
`;

export const Wrapper = styled.div`
  width: 50%;
  margin-left: 50%;
`;

export const Title = styled.div<{ pattern?: string }>`
  text-shadow: ${({ pattern }) =>
    pattern == 'primary'
      ? '3px 4px 7px rgba(0, 0, 0, 0.2)'
      : pattern == 'secondary'
      ? '3px 4px 7px rgba(0, 0, 0, 0.75)'
      : 'inherit'};
  color: ${({ pattern }) =>
    pattern == 'primary'
      ? 'rgba(32, 154, 214, 1)'
      : pattern == 'secondary'
      ? 'rgba(255, 255, 255, 1)'
      : 'inherit'};

  font-size: 2.5rem;
  font-weight: 600;
  ${({ theme }) => theme.breakpoints.down('xl')} {
    font-size: 2rem;
  }
  ${({ theme }) => theme.breakpoints.down('lg')} {
    font-size: 1.3rem;
  }
  ${({ theme }) => theme.breakpoints.down('sm')} {
    font-size: 1rem;
    width: 80%;
    font-weight: 500;
  }
`;

export const SubTitle = styled.div<{ pattern?: string }>`
  text-shadow: ${({ pattern }) =>
    pattern == 'primary'
      ? '3px 4px 7px rgba(0, 0, 0, 0.2)'
      : pattern == 'secondary'
      ? '3px 4px 7px rgba(0, 0, 0, 0.75)'
      : 'inherit'};
  color: ${({ pattern }) =>
    pattern == 'primary'
      ? 'rgba(32, 154, 214, 1)'
      : pattern == 'secondary'
      ? 'rgba(255, 255, 255, 1)'
      : 'inherit'};
  font-size: 1.5rem;
  font-weight: 200;
  margin-top: 1%;
  width: 80%;
  ${({ theme }) => theme.breakpoints.down('xl')} {
    font-size: 1.2rem;
  }
  ${({ theme }) => theme.breakpoints.down('lg')} {
    font-size: 0.9rem;
  }
  ${({ theme }) => theme.breakpoints.down('sm')} {
    display: none;
  }
`;

export const ShopNowButton = styled.div<{ pattern?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20%;
  padding: 10px 3px;
  margin-top: 2rem;
  background: ${({ pattern }) =>
    pattern == 'primary'
      ? 'rgba(32, 154, 214, 1)'
      : pattern == 'secondary'
      ? 'rgba(255, 255, 255, 1)'
      : 'inherit'};
  color: ${({ pattern }) =>
    pattern == 'primary'
      ? 'rgba(255, 255, 255, 1)'
      : pattern == 'secondary'
      ? 'rgba(32, 154, 214, 1)'
      : 'inherit'};

  font-size: 1.1rem;
  border-radius: ${({ theme }) => theme.borderRadius};
  cursor: pointer;
  border: none;
  > span {
    font-weight: 500;
  }
  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 40%;
    font-size: 0.8rem;
    padding: 4px 8px;
    margin-top: 0.2rem;
    > span {
      font-weight: 300;
    }
  }
`;

export const CustomCarousel = styled(Carousel)<{ $width: number }>`
  width: ${({ $width }) => $width + 'px'};
  position: relative;

  // Centering the carousel in the middle of the screen with custom width.
  // In browser this should look something like this ->
  // width is eg.: 1713px
  // left: calc(50% - 856.5px);
  left: ${({ $width }) => `calc(50% - ${$width / 2}px)`};

  // customizing default pagination dots (navigation)
  .react-multi-carousel-dot > button {
    margin-bottom: 10px;
    height: 11px;
    width: 11px;

    background: #ccc;
    border: unset;
  }

  // customizing "active slide" pagination dots (navigation)
  .react-multi-carousel-dot--active > button {
    background: white;
    border: 0.7px #ccc solid;
  }
`;
